/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router";
import ReferralPartnerServices from "../../services/API/ReferralPartner";
import Loader from "../../components/Loader";
// import SpocList from "./SpocList";
import { useState, useEffect } from "react";
import CustomModal from "../../components/common/CustomModal";
import { toast } from "react-toastify";
import RejectReferralPartner from "./RejectReferralPartner";
import { formatMobileNumber } from "../../utils/utils";
import FullScreenLoader from "../../components/FullScreenLoader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";

const ReferralPartnerDetails = () => {
  const { id } = useParams();
  const [showmodal, setShowModal] = useState("");
  const [loader, setLoader] = useState("");
  const [userCoupons, setUserCoupons] = useState([]);
  const navigate = useNavigate();
  const queryKey = `/api/referral-partner/edit/${id}`;
  const {
    data: referralPartnerDetails,
    isLoading,
    isFetching,
    isSuccess,
    refetch,
  } = useQuery([queryKey, { id }], ReferralPartnerServices.getReferralPartnerDetails, {
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
  });

  const referralPartnerData = referralPartnerDetails?.data[0];

  const approveRequest = async () => {
    setShowModal("");
    setLoader("approve");
    const resp = await ReferralPartnerServices.updateReferralPartnerRequest(id, 1);
    setLoader("");
    if (resp) {
      setShowModal("approveConfirm");
    }
  };

  const downloadSingleFile = async (docName, docId, ext) => {
    try {
      let type = "";
      referralPartnerDetails.referral_partner_documents?.forEach((item) => {
        if (item.id === docId) {
          type = item.type.split("/")[1];
        }
      });

      const response = await ReferralPartnerServices.downloadSingleDocument(
        docId
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        var name = (docName) ? docName + '.' + ext : 'Document.' + ext;
        link.setAttribute("download", name);
        link.click();
        toast.success("Document Downloaded Successfully");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (referralPartnerData?.id) {
      couponDetails(referralPartnerData?.id);
    }
  }, [referralPartnerData]);

  const couponDetails = async (id) => {
    const resp = await ReferralPartnerServices.getUserCouponDetails({ id: id });
    if (resp?.status == 'Success') {
      setUserCoupons(resp?.data);
    }
  };

  return (
    <>
      {loader === "approve" ? (
        <FullScreenLoader show={loader === "approve"} title="updating status" />
      ) : (
        ""
      )}

      <div id="main" className="main">
        <div id="content" className="content">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                href="#"
                onClick={() => navigate("/alliance-manager/dashboard")}
              >
                Home
              </a>
            </li>
            <li className="breadcrumb-item">
              <a href="#" onClick={() => navigate("/alliance-manager/referral-partners")}>
                Referral Partner
              </a>
            </li>
            <li className="breadcrumb-item active">Referral Partner Details</li>
          </ol>
          {isLoading ? (
            // <Loader />
            <FullScreenLoader show={true} title="" />
          ) : (
            <div className="row">
              <div className="card card-sm card-shadow mb-3">
                <CustomModal
                  show={showmodal === "approve"}
                  onClose={() => setShowModal("")}
                  headerTitle="Are you sure?"
                  onSubmit={approveRequest}
                  onSubmitText={"Yes"}
                  onCloseText="No"
                >
                  <div>Do you want to approve this Request?</div>
                </CustomModal>
                <CustomModal
                  show={showmodal === "approveConfirm"}
                  footer={<></>}
                  onClose={() => {
                    setShowModal("");
                    refetch();
                  }}
                  headerTitle={
                    <h3 class="modal-title">
                      Referral Partner Request : <span class="txt-success">Approved</span>
                    </h3>
                  }
                >
                  <p>The new Referral Partner request is successfully approved.</p>
                  <p>The user credentials has been sent on email.</p>
                </CustomModal>
                <RejectReferralPartner
                  show={showmodal === "reject"}
                  onClose={() => setShowModal("")}
                  id={id}
                />

                <div className="card-body">
                  <h2>View Referral Partner Details</h2>
                  {referralPartnerData?.status == 2 ? (
                    <>
                      <span
                        // href="#"
                        className=" button_new pull-right"
                        style={{ marginRight: "85px", cursor: "pointer" }}
                        onClick={() => setShowModal("approve")}
                        onKeyDown={() => setShowModal("approve")}
                      >
                        <i class="fa fa-check txt-success fa-fw"></i>Approve
                      </span>
                      <span
                        className=" button_new pull-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowModal("reject")}
                        onKeyDown={() => setShowModal("reject")}
                      >
                        <i class="fa fa-times txt-fail fa-fw"></i>Reject
                      </span>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="row mt-3">
                    <article className="col-lg-12  mb-3">
                      <div className="card card-sm card-shadow mb	-3">
                        <div className="card-body">
                          <span className="font-xl ">{referralPartnerData?.name}</span>

                          <div className="row">
                            <section className="col col-6 ">
                              <div className="mt-4">
                                <i
                                  className="fa fa-building fa-fw"
                                  aria-hidden="true"
                                  style={{ color: "#64308e", marginRight: "2px" }}
                                  title="Organization Name"
                                ></i>
                                <span className="note">Organization Name : </span>

                                <span>{referralPartnerData?.organization_name}</span>
                              </div>
                              <div className="mt-4">
                                <i
                                  className="fa fa-envelope fa-fw"
                                  aria-hidden="true"
                                  // style="color: #64308e;"
                                  title="Email Id"
                                ></i>
                                <span className="note">Email ID : </span>
                                {referralPartnerData?.email}
                              </div>
                            </section>
                            <section className="col col-6">
                              <div className="mt-4">
                                <i
                                  className="fa fa-phone fa-fw"
                                  aria-hidden="true"
                                  // style="color: #64308e;"
                                  title="Mobile Number"
                                ></i>
                                <span className="note">Mobile No : </span>
                                {referralPartnerData?.mobile_no
                                  ? formatMobileNumber(referralPartnerData?.mobile_no)
                                  : "--"}
                              </div>
                              <div className="mt-4">
                                {referralPartnerData?.status == 0 ? (
                                  <span>
                                    <i className="fa fa-circle fa-fw txt-fail" title="Status"></i>
                                    <span className="note">Status: </span>
                                    Inactive
                                  </span>
                                ) : (
                                  ""
                                )}

                                {referralPartnerData?.status == 1 ? (
                                  <span>
                                    <i className="fa fa-circle fa-fw txt-success" title="Status"></i>
                                    <span className="note">Status: </span>
                                    Active
                                  </span>
                                ) : (
                                  ""
                                )}

                                {referralPartnerData?.status == 2 ? (
                                  <span>
                                    <i className="fa fa-circle fa-fw txt-blue" title="Status"></i>
                                    <span className="note">Status : </span>
                                    Pending Authentication
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </section>


                          </div>
                        </div>
                        <div className="card-body">
                          <h3
                            style={{ marginBottom: "0 !important" }}
                            className="heading_light"
                          >
                            Documents List
                          </h3>
                          <section className="col col-12">
                            <div className="table-responsive">
                              <table className="table table-bordered eg-1 mt-3">
                                <thead>
                                  <tr style={{ fontSize: "12px", fontWeight: "700" }}>
                                    <th style={{ textAlign: "center", width: "30%" }}>
                                      Document Name
                                    </th>
                                    <th style={{ textAlign: "center" }}>Document</th>
                                    <th style={{ textAlign: "center", width: "20%" }}>
                                      Uploaded on
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {referralPartnerData?.referral_partner_documents?.length > 0 &&
                                    referralPartnerData?.referral_partner_documents?.map((item, i) => {
                                      return (
                                        <tr key={i} style={{ fontSize: "12px" }}>
                                          <td>
                                            <strong>{item?.doc_name}</strong>
                                          </td>
                                          <td>
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip id="tooltip-disabled">Download</Tooltip>
                                              }
                                            >
                                              <i
                                                className="fa-solid fa-file-arrow-down"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  downloadSingleFile(
                                                    item.name,
                                                    item.id,
                                                    item.extension
                                                  )
                                                }
                                                onKeyDown={() =>
                                                  downloadSingleFile(
                                                    item.name,
                                                    item.id,
                                                    item.extension
                                                  )
                                                }
                                              ></i>
                                            </OverlayTrigger>
                                            &nbsp; {`${item?.name}.${item?.extension}`}
                                          </td>
                                          <td>
                                            {moment(item?.created_at).format("DD-MM-YY hh:mm A")}
                                          </td>
                                        </tr>
                                      );
                                    }
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </section>
                        </div>
                        <div className="card-body">
                          <section className="col col-12">
                            <h3
                              style={{ marginBottom: "0 !important" }}
                              className="heading_light"
                            >
                              Coupons List
                            </h3>
                            <div className="table-responsive">
                              <table className="table table-bordered eg-1 mt-3">
                                <thead>
                                  <tr style={{ fontSize: "12px", fontWeight: "700" }}>
                                    <th style={{ textAlign: "center", width: "30%" }}>
                                      Coupon Code
                                    </th>
                                    <th style={{ textAlign: "center" }}>Used Count</th>
                                    <th style={{ textAlign: "center" }}>User Discount</th>
                                    <th style={{ textAlign: "center", width: "20%" }}>
                                      Partner Commission
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {userCoupons?.length > 0 &&
                                    userCoupons?.map((item, i) => {
                                      return (
                                        <tr key={i} style={{ fontSize: "12px" }}>
                                          <td>
                                            {item?.coupon_code}
                                          </td>
                                          <td>
                                            {item?.used_count}
                                          </td>
                                          <td>
                                            {item?.discount_amount}
                                          </td>
                                          <td>
                                            {item?.commission_amount}
                                          </td>
                                        </tr>
                                      );
                                    }
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </section>
                        </div>
                      </div>
                    </article>
                  </div>
                  {/* <SpocList id={id}status={referralPartnerData?.status}/> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReferralPartnerDetails;